import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { collection, query, where, onSnapshot, Timestamp } from 'firebase/firestore';
import { db } from '../services/firebaseConfig';
import { RootState, AppDispatch } from '../redux/store';
import {
  setProcessedRollen,
  setLoading,
  setError,
  clearProcessedRollen,
} from '../redux/slices/subtasksProcessedSlice';
import { SubtasksProcessed } from '../models/SubtasksProcessed';

const convertFirestoreData = (doc: any): SubtasksProcessed => {
  const data = doc.data();
  return {
    id: doc.id,
    ...data,
    createdAt:
      data.createdAt instanceof Timestamp ? data.createdAt.toDate().toISOString() : data.createdAt,
    updatedAt:
      data.updatedAt instanceof Timestamp ? data.updatedAt.toDate().toISOString() : data.updatedAt,
  } as SubtasksProcessed;
};

export const useSubtasksProcessed = (problemId: string, userId: string) => {
  const dispatch = useDispatch<AppDispatch>();
  const processedSubtasks = useSelector(
    (state: RootState) => state.subtasksProcessed.processedSubtasks
  );
  const loading = useSelector((state: RootState) => state.subtasksProcessed.loading);
  const error = useSelector((state: RootState) => state.subtasksProcessed.error);

  useEffect(() => {
    dispatch(setLoading(true));

    const processedSubtasksQuery = query(
      collection(db, 'processed_subtasks'),
      where('problemId', '==', problemId),
      where('userId', '==', userId)
    );

    const unsubscribe = onSnapshot(
      processedSubtasksQuery,
      snapshot => {
        const processedRollenList: SubtasksProcessed[] = [];
        snapshot.forEach(doc => {
          processedRollenList.push(convertFirestoreData(doc));
        });
        dispatch(setProcessedRollen(processedRollenList));
        dispatch(setLoading(false));
      },
      error => {
        console.error('Error fetching processed roles:', error);
        dispatch(setError(error.message));
        dispatch(setLoading(false));
      }
    );

    return () => {
      unsubscribe();
      dispatch(clearProcessedRollen());
    };
  }, [dispatch, problemId, userId]);

  return {
    processedRollen: processedSubtasks,
    loading,
    error,
  };
};
